import { GET_ADMIN_BY_ID, GET_ADMIN_LIST } from "../constants";

export const admin = (state = { adminList: [], updateadmin: {} }, action) => {
  switch (action.type) {
    case GET_ADMIN_LIST:
      return { ...state, adminList: action.adminList };
    case GET_ADMIN_BY_ID:
      return { ...state, updateadmin: action.updateadmin };
    default:
      return state;
  }
};
